export const isSignedIn = ({user}) => user.inSignedIn;
